// Sticky purchase rail for the course page.
//
// The rail appears only once the hero's purchase cards have scrolled past the
// top of the viewport, which is what keeps one accent fill per viewport: the
// hero's "Join the Pro Plan" button is gone before the rail's exists. With this
// script absent the rail stays hidden and nothing is lost, because every
// control in it is already in the hero.
//
// NOT VERIFIABLE IN HEADLESS OR EMBEDDED-PREVIEW QA. Measured 2026-08-28: those
// browsers report document.visibilityState === "hidden" permanently, and a
// hidden document fires no IntersectionObserver callbacks, no rAF and no scroll
// events even while window.scrollY changes. A rail built on any of the three
// therefore looks broken under automation and is fine for a real visitor. Check
// it in a foreground window, not from a capture.
(function () {
  var rail = document.querySelector('[data-ds-rail]');
  var anchor = document.querySelector('.ds-buy');
  if (!rail || !anchor || !('IntersectionObserver' in window)) return;

  new IntersectionObserver(
    function (entries) {
      // Past, not merely absent: the cards must have left through the TOP, so
      // scrolling back up hides the rail again rather than latching it on.
      var e = entries[0];
      var past = !e.isIntersecting && e.boundingClientRect.bottom < 0;
      rail.hidden = !past;
      document.documentElement.classList.toggle('ds-has-rail', past);
    },
    { threshold: 0 }
  ).observe(anchor);
})();
